import { GeneralTooltip } from '@components/common/GeneralTooltip';
import { getMaterialIconType } from '../../helpers/iconHelper';
import type { TMaterialIconType } from '../../interfaces/IGeneral';

interface IMaterialIconProps {
  icon: string;
  type?: TMaterialIconType;
  classes?: string[];
  onClick?: CallableFunction;
  role?: string;
  id?: string;
  colorHex?: string;
  disabled?: boolean;
  tooltip?: string;
  tooltipPosition?: 'top' | 'bottom' | 'left' | 'right';
}

export const MaterialIcon: React.FC<IMaterialIconProps> = ({
  icon,
  type,
  classes,
  onClick,
  role,
  id,
  colorHex,
  disabled,
  tooltip,
  tooltipPosition = 'top',
}) => {
  // * Prepare material icons classes
  const iconType = getMaterialIconType(type);
  // * Add optional class names
  let iconClasses = classes ? classes.join(' ') : '';

  // * Add disabled styling if applicable
  if (disabled) {
    iconClasses = `${iconClasses} !opacity-50 !cursor-not-allowed`;
  }

  const iconElement = (
    <span
      id={id}
      role={role}
      onClick={(e) => onClick?.(e)}
      className={`${iconType} ${iconClasses} select-none ${onClick ? 'cursor-pointer' : ''}`}
      style={{ color: colorHex }}>
      {icon}
    </span>
  );

  // * If tooltip exists, wrap with GeneralTooltip
  if (tooltip) {
    return (
      <GeneralTooltip
        parentClassName='flex'
        className='max-w-[220px] text-center'
        text={tooltip}
        placement={tooltipPosition}>
        {iconElement}
      </GeneralTooltip>
    );
  }

  // * Return plain icon if no tooltip
  return iconElement;
};

export default MaterialIcon;
